import * as React from 'react'
import Helmet from 'react-helmet'

import * as banner from "./../assets/about-banner.jpg"
import * as profileimg from "./../assets/profile.jpg"
import * as hslogo1 from "./../assets/homeshowlogos-01.jpg"
import * as hslogo2 from "./../assets/homeshowlogos-02.jpg"
import * as hslogo3 from "./../assets/homeshowlogos-03.jpg"
import * as hslogo4 from "./../assets/homeshowlogos-04.jpg"

import './about-us.css'

// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
  data: {
    site: {
      siteMetadata: {
        title: string
      }
    }
  }
}

export default class extends React.Component<IndexPageProps, {}> {
  constructor(props: IndexPageProps, context: any) {
    super(props, context)
  }
  public render() {
    return (
      <div>
        <Helmet
            bodyAttributes={{
                class: 'about-body'
            }}
        />

        <div className="caption-container">
            <img width={980} height={273} alt="Fourth" src={banner} style={{margin: 0}}/>
            <h1 className="caption">COMPANY REALIZING THE DREAM WITH CUSTOMERS..</h1>
        </div>

        <div style={{
            height: "auto",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "1px 25px 15px",
            marginBottom: "10px",
          }}>

          <p className="about-para">
            Under Juniper is a premier landscape architecture and general construction company providing architectural design-build services. Every project we propose to you starts with architectural design created by our principal landscape architect - Dr. Choi - who specializes in landscape architecture and forestry.
          </p>

          <hr style={{margin: 0, marginTop: '2px', borderColor: 'rgb(150, 150, 150)'}}/>

          <h2 className="about-title">MEET THE <span style={{color: "#346B1F"}}>TEAM</span></h2>

          <div className="profilediv">
            <div className="profile-left">
              <p style={{fontFamily: "Helvetica", fontSize: "13px", height: "36px", width: "143px", margin: "0px", marginBottom: "20px"}}>Kye Choi, PhD, ASLA <br/> Principal/CEO</p>
              <img width={143} height={180} alt="Profile" src={profileimg}/>
            </div>
            
            <p className="title-desc">
              Dr. Choi began his career in landscape architecture and construction industry 25 years ago. He received his Masters degree and was a PhD candidate in Landscape Architecture from Sungkyunkwan University.  Then he obtained his PhD in Forestry and Natural Resources Management at the State University of New York College of Environmental Science & Forestry in association with Syracuse University.<br/><br/>
              Over the past couple decades; he worked for top design and land development companies such as Samsung Everland as the senior project manager. He was responsible for coordinating international consultants and preparing master plans for large-scale commercial and recreational facilities including golf courses, ski resorts, theme parks, hotel and resort complexes, shopping malls, campgrounds, etc.<br/><br/>
              As the principal landscape architect in Under Juniper, Inc., he specializes in a public participation design process for sustainable development to analyze user groups and potential markets for better design and construction services.<br/><br/>
              He is currently a registered landscape architect in the U.S. State of Nevada; licensed in landscaping, general engineering and building construction in the state of California; and invited as a professor of the College of Architecture by Hongik University in Seoul, Korea.<br/><br/>
              As a professor at Hongik University, he has been giving numerous industry related academic lectures to both under-graduate and graduate program students.<br/>
            </p>
          </div>
        </div>

        <div style={{
            height: "auto",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "1px 25px 15px",
            marginBottom: "10px"
          }}>

          <p className="title">Calvin Ahn <br/>AIA, LEED AP</p>

          <p className="title-desc">
            As a principal and CVO of New York office, Calvin Ahn has provided leadership and commitment to the core values of the firm since established and has over 10 years of project management experience on architectural design and construction projects in New York. He graduated from the University of Southern California and holds a Master of Architecture degree from Syracuse University in New York.
          </p>

          <hr style={{margin: 0, marginTop: '20px', borderColor: 'rgb(150, 150, 150)'}}/>

          <p className="title">Sujan Kim <br/>VP, Business Administration</p>

          <p className="title-desc">
            Sujan is Vice President of administration and project management for the California office; she assists Dr. Choi in carefully designing and planning each project. She is responsible for all accounting and business related endeavours. She studied Applied Art and Industrial Design for her bachelor's degree in Korea and studied Textile Design in Syracuse University.
          </p>

          <hr style={{margin: 0, marginTop: '20px', borderColor: 'rgb(150, 150, 150)'}}/>

          <p className="title">Joshua Choi<br/>PM, IT Administrator</p>

          <p className="title-desc">
            Joshua is Project Manager and maintains information technology related and all other internet based services in the company. He ensures the quality and stability of all technology in the office. Graduated with a B.S. in  Software Engineering at California Polytechnic State University, San Luis Obispo.
          </p>

          <hr style={{margin: 0, marginTop: '20px', borderColor: 'rgb(150, 150, 150)'}}/>

          <p className="title">Sohyung Choi<br/>Senior Landscape Designer</p>

          <p className="title-desc">
            Sohyung joined Under Juniper, LLC. in 2015 as the principal 2D/3D landscape designer. She has a BA from University of California, Davis and a MFA from Mills College, Oakland.
          </p>

          <hr style={{margin: 0, marginTop: '20px', borderColor: 'rgb(150, 150, 150)'}}/>

          <p className="title">Sergio Tapia<br/>Construction Manager</p>

          <p className="title-desc">
            As a construction manager, Sergio coordinates and supervises a wide variety of projects, including the building of all types of residential and commercial landscape structures. Not only he schedules and coordinates all construction processes to ensure a productive and safe work environment but also selects appropriate construction methods and strategies to make sure jobs are completed on time. 
          </p>
        </div>

        <div style={{
            height: "auto",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "1px 25px 40px",
          }}>
            <h2 className="about-title">EXHIBITION <span style={{color: "#68B04D"}}>SCHEDULES</span></h2>

            <div style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              flexWrap: 'wrap',
            }}>
              <div className="exhib-container">
                <div>
                  <p style={{textAlign: "center"}}>AUGUST</p>
                </div>

                <a href="http://www.calstateshows.com/" target="_blank">
                  <img width={140} height={144} alt="homeshowlogo-01" src={hslogo1}/>
                </a>

                <p style={{textAlign: "center"}}>18, 19 & 20, 2017</p>

                <p className="exhib-desc">​
                  McClellan Business Park<br/>
                  Jackson Sports Academy<br/>
                  5209  Luce Ave.<br/>
                  McClellan, CA 95652<br/>
                </p>

                <a href="http://www.calstateshows.com/" target="_blank">
                  <p className="exhib-readmore">
                    READ MORE >
                  </p>
                </a>
              </div>

              <div className="exhib-container">
                <div>
                  <p style={{textAlign: "center"}}>SEPTEMBER</p>
                </div>

                <a href="http://www.auburnhomeshows.com/" target="_blank">
                  <img width={140} height={144} alt="homeshowlogo-02" src={hslogo2}/>
                </a>

                <p style={{textAlign: "center"}}>29, 30 & Oct. 1, 2017</p>

                <p className="exhib-desc">​
                  Gold Country Fairgrounds<br/>
                  & Event Center<br/>
                  1273 High Street<br/>
                  Auburn, CA 95603<br/>
                </p>

                <a href="http://www.auburnhomeshows.com/" target="_blank">
                  <p className="exhib-readmore">
                    READ MORE >
                  </p>
                </a>
              </div>

              <div className="exhib-container">
                <div>
                  <p style={{textAlign: "center"}}>OCTOBER</p>
                </div>

                <a href="http://www.sachomeandgardenshow.com/" target="_blank">
                  <img width={140} height={144} alt="homeshowlogo-03" src={hslogo3}/>
                </a>

                <p style={{textAlign: "center"}}>13, 14 & 15, 2017</p>

                <p className="exhib-desc">​
                  Cal Expo<br/>
                  Pavilion<br/>
                  1600 Exposition Blvd.<br/>
                  Sacramento, CA 95815<br/>
                </p>

                <a href="http://www.sachomeandgardenshow.com/" target="_blank">
                  <p className="exhib-readmore">
                    READ MORE >
                  </p>
                </a>
              </div>

              <div className="exhib-container">
                <div>
                  <p style={{textAlign: "center"}}>JANUARY</p>
                </div>

                <a href="http://www.homeandlandscapeexpo.com/site/index.php" target="_blank">
                  <img width={140} height={144} alt="homeshowlogo-04" src={hslogo4}/>
                </a>

                <p style={{textAlign: "center"}}>26, 27 & 28, 2017</p>

                <p className="exhib-desc">​
                  Cal Expo<br/>
                  Fairgrounds<br/>
                  1600 Exposition Blvd.<br/>
                  Sacramento, CA 95815<br/>
                </p>

                <a href="http://www.homeandlandscapeexpo.com/site/index.php" target="_blank">
                  <p className="exhib-readmore">
                    READ MORE >
                  </p>
                </a>
              </div>
            </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/about-us.tsx